import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@web/components/ui/accordion";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@web/components/ui/card";
import { useLanguage } from "@web/lib/contexts/language-context";
import { useFaqs } from "@web/lib/hooks/faqs";
import { HelpCircle } from "lucide-react";

function getLocalizedValue(
	item: any,
	field: "title" | "description",
	lang: string,
) {
	const suffixMap: Record<string, string> = {
		pt: "Pt",
		en: "En",
		fr: "Fr",
		ar: "Ar",
	};

	const suffix = suffixMap[lang] || "Pt";
	const key = `${field}${suffix}`;

	return item[key] || item[`${field}Pt`];
}

export function FaqPage() {
	const { t, language } = useLanguage();
	const { data: faqs } = useFaqs();

	return (
		<div className="w-full flex flex-1 items-center justify-center">
			<main className="flex flex-1 flex-col items-center p-4 md:p-8">
				<Card className="w-full max-w-3xl py-0">
					<CardHeader className="border-b bg-primary/5 rounded-t-xl p-6">
						<div className="flex items-center gap-3">
							<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
								<HelpCircle className="h-5 w-5 text-primary" />
							</div>
							<div>
								<CardTitle className="text-xl">{t.faqPage.title}</CardTitle>
								<CardDescription className="mt-1">
									{t.faqPage.subtitle}
								</CardDescription>
							</div>
						</div>
					</CardHeader>

					<CardContent>
						<Accordion type="single" collapsible className="w-full">
							{faqs?.map((item, index) => (
								<AccordionItem key={index} value={`item-${index}`}>
									<AccordionTrigger className="text-left font-medium hover:no-underline hover:text-primary">
										{getLocalizedValue(item, "title", language)}
									</AccordionTrigger>

									<AccordionContent className="text-muted-foreground leading-relaxed">
										{getLocalizedValue(item, "description", language)}
									</AccordionContent>
								</AccordionItem>
							))}
						</Accordion>
					</CardContent>
				</Card>
			</main>
		</div>
	);
}
